const dateFormat = require('dateformat');

export default {
  /**
   * 格式化时间戳为字符串
   * @param  {Number} timestamp unix时间戳
   * @param  {String} format    格式化字符串，仅支持关键字母：YmdHis
   * @return {String}
   *
  * 格式文档： https://www.npmjs.com/package/dateformat
   */
  formatTime: (timestamp, format) => {
    if (typeof (timestamp) !== 'number') {
      return '';
    }

    const date = new Date();
    return dateFormat(new Date(timestamp * 1000 + date.getTimezoneOffset() * 60 * 1000 + 8 * 60 * 60 * 1000), format);
  },

  handleImageUrl: (url, width, height) => {
    // return `${url}?x-oss-process=image/resize,w_${width},h_${height}`;
    // 删除图片的尺寸后缀
    return `${url}`;
  },

  /**
   * 省略字符串，中间加...
   * @param  {String} source 源字符串
   * @param  {Number} length 保留的长度
   * @return {String}
   */
  omitString: (source, length) => {
    if (source.length <= length) {
      return source;
    }

    const halfLength = Math.floor(length / 2);

    const beginStr = source.substr(0, halfLength);
    const endIndex = length % 2 === 1 ?
      source.length - halfLength :
      source.length - halfLength + 1;
    const endStr = source.substr(endIndex)

    return `${beginStr}...${endStr}`;
  },

  /**
   * 省略字符串
   * @param  {String} source 源字符串
   * @param  {Number} length 保留的长度
   * @return {String}
   */
  omitStringByEnd: (source, length) => {
    if (!source || source.length <= length) {
      return source;
    }

    return source.substr(0, length);
  },
  
  couponType(type) {
    if (type == 'CASH') {
      return '代金券';
    }
  
    if (type == 'DISCOUNT') {
      return '折扣券';
    }
  
    return '助学金';
  }
};
